import React from 'react';
import { useNavigate } from 'react-router-dom';
import './news.css';

interface NewsProps{
    id?: string,
    image: string;
    alt?: string | undefined;
    date?: string;
    title?: string;
    description?: string
}

export const News = ({
    title = "",
    description = "",
    date = "",
    alt = undefined,
    image,
    id = ""
}: NewsProps) => {
    const navigate = useNavigate();
    const alternative = alt ? alt : title;
    return <div className="news-container transition hover:-translate-y-5 cursor-pointer" onClick={() => navigate(`/news/${id}`)}>
        <img src={image} alt={alternative} className="news-image"/>
        <p className="text-2xl mt-5">{title}</p>
        <p className="news-date text-gray-500">{date}</p>
        <p className="news-description text-lg">{description}</p>
    </div>
}